import prism from '@theme-ui/prism/presets/prism-solarizedlight.json';

export default {
  ...prism,
  borderRadius: 16,
  padding: 4,
};
